import type { ImageProps } from './Image'

export function imagePropsToClassNames({
    className,
    ellipse,
    objectFit,
    objectPosition,
}: Partial<ImageProps>) {
    const classNames = className ? [className] : []
    if (ellipse) {
        classNames.push('rounded-full')
    }
    if (objectFit) {
        classNames.push('object-' + objectFit)
    }
    if (objectPosition) {
        classNames.push('object-' + objectPosition)
    }
    return classNames
}
